import { render, staticRenderFns } from "./pageHeader.vue?vue&type=template&id=db6a4c34&scoped=true"
import script from "./pageHeader.vue?vue&type=script&lang=js"
export * from "./pageHeader.vue?vue&type=script&lang=js"
import style0 from "./pageHeader.vue?vue&type=style&index=0&id=db6a4c34&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6a4c34",
  null
  
)

export default component.exports